import moment from "moment"

export const calculateTimeDifferenceInMinutes = (
    time1,
    time2,
    dayRelation
) => {
    const format = "YYYY/MM/DD hh:mm A"

    const currentYear = new Date().getFullYear()
    const moment1 = moment(`${currentYear}/01/15 ${time1}`, format)
    const moment2 = moment(`${currentYear}/01/15 ${time2}`, format)

    if (dayRelation === "nextDay") {
        moment2.add(1, "day")
    } else if (dayRelation === "previousDay") {
        moment2.subtract(1, "day")
    }

    return Math.abs(moment1.diff(moment2, "minutes"))
}

export const formatMinutesToHours = (minutes) => {
    const duration = moment.duration(minutes, "minutes")
    const hours = Math.floor(duration.asHours())
    const mins = duration.minutes()

    if (hours === 0) {
        return `${mins} min`
    }
    return mins === 0 ? `${hours}hr` : `${hours}hr ${mins} min`
}


export const formatDateLabel = (dateStr) => {
    if (!dateStr) return null;

    const date = moment(dateStr, "YYYY-MM-DD");
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "days").startOf("day");

    if (date.isSame(today, "d")) {
        return "Today";
    } else if (date.isSame(yesterday, "d")) {
        return "Yesterday";
    } else if (date.isAfter(moment().subtract(7, "days"))) {
        return date.format("dddd");
    } else {
        return date.format("MMMM D, YYYY");
    }
};

export const DEFAULT_TIMEZONE = "America/New_York";

export const timeLeftToAcceptOrDecline = (
    booking_created_at,
    class_date,
    class_time,
    timezone,
    original_class_date = null,
    original_class_time = null
) => {
    const ONE_MINUTE_IN_MS = 60 * 1000;
    const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;
    const TWENTY_FOUR_HOURS_IN_MS = 24 * ONE_HOUR_IN_MS;
    const TWENTY_FIVE_HOURS_IN_MS = 25 * ONE_HOUR_IN_MS;
    const ACCEPTANCE_WINDOW_IN_MS = TWENTY_FOUR_HOURS_IN_MS - ONE_MINUTE_IN_MS;

    const tz = timezone || DEFAULT_TIMEZONE

    const bookingTime = moment(booking_created_at).valueOf();

    const rescheduledTime = moment
        .tz(
            `${class_date} ${class_time}`,
            "YYYY-MM-DD HH:mm:ss",
            tz
        )
        .valueOf();

    const hasOriginal = original_class_date && original_class_time

    if (!hasOriginal) {
        // CASE A: No original class
        const isAfter25h = rescheduledTime - bookingTime > TWENTY_FIVE_HOURS_IN_MS;

        return isAfter25h
            ? bookingTime + ACCEPTANCE_WINDOW_IN_MS
            : rescheduledTime - ONE_HOUR_IN_MS;
    }

    // CASE B: Original class exists (reschedule flow)
    const originalTime = moment
        .tz(`${original_class_date} ${original_class_time}`, "YYYY-MM-DD HH:mm:ss", tz)
        .valueOf();

    const originalWithin25h = originalTime - bookingTime <= TWENTY_FIVE_HOURS_IN_MS;
    const originalIsSooner = originalTime < rescheduledTime;

    if (originalWithin25h && originalIsSooner) {
        // Special case: original is sooner & within 25h
        return originalTime - ONE_HOUR_IN_MS;
    }

    const rescheduleWithin25h = rescheduledTime - bookingTime <= TWENTY_FIVE_HOURS_IN_MS;

    if (rescheduleWithin25h) {
        // Use rescheduled class deadline
        return rescheduledTime - ONE_HOUR_IN_MS;
    }

    // Default: rescheduled is far in the future
    return bookingTime + ACCEPTANCE_WINDOW_IN_MS;
};


